export default {
  methods: {
    menuItemFound(value, items) {
      let result = false;

      items.forEach(item => {
        if (value.includes(item.link.path)) {
          result = true;
        }
      });

      return result;
    }
  }
};
